
import React from 'react';
import VuiBox from 'components/VuiBox';
import VuiTypography from 'components/VuiTypography';
import VuiButton from 'components/VuiButton';
import { Card } from '@mui/material';

const SubscriptionNotice = () => {
  const handleRedirectToBilling = () => {
    // Lógica para obter o link do portal de pagamentos da Stripe
    // Por enquanto, vamos usar uma URL de exemplo.
    // Idealmente, isso viria de uma chamada de API para o backend.
    window.location.href = 'https://buy.stripe.com/test_...'; // Substituir pelo link real
  };

  return (
    <VuiBox
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(10px)',
        zIndex: 9999, // Garante que fique sobre todo o conteúdo
      }}
    >
      <Card sx={{ p: 4, maxWidth: '500px', textAlign: 'center' }}>
        <VuiTypography variant="h3" color="white" fontWeight="bold" mb={2}>
          Verifique sua Assinatura
        </VuiTypography>
        <VuiTypography variant="body2" color="text" mb={3}>
          O acesso às funcionalidades foi temporariamente suspenso. Para reativar seu acesso, por favor, regularize sua assinatura.
        </VuiTypography>
        <VuiButton variant="contained" color="info" onClick={handleRedirectToBilling}>
          Ir para Pagamentos
        </VuiButton>
        <VuiTypography variant="caption" color="text" mt={2} component="p">
          Se você acredita que isso é um erro, por favor, entre em contato com nosso <a href="https://wa.me/5511989205971?text=Oi%20Roberto!%20Preciso%20de%20ajuda%20com%20a%20assinatura%20no%20SaferDock." target="_blank" rel="noopener noreferrer">suporte</a>.
        </VuiTypography>
      </Card>
    </VuiBox>
  );
};

export default SubscriptionNotice;
